import type { BlockNoteEditor } from '@blocknote/core';
import * as React from 'react';

/**
 * Keeps the browser viewport aligned with the current selection during keyboard
 * navigation inside the editor.
 */
export function useSelectionAutoScroll(editor: BlockNoteEditor): void {
  React.useEffect(() => {
    const unsubscribe = editor.onSelectionChange(() => {
      requestAnimationFrame(() => {
        const selection = window.getSelection();
        const range = selection?.rangeCount ? selection.getRangeAt(0) : null;

        // Keep keyboard navigation visible without smooth-scroll lag while typing.
        range?.commonAncestorContainer.parentElement?.scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'nearest',
        });
      });
    });

    return unsubscribe;
  }, [editor]);
}
